module.exports = __webpack_public_path__ + "static/img/coupon_overdue.f831a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/benefits/coupon_overdue.png
// module id = 1482
// module chunks = 192